import { useSyncExternalStore } from 'react'
import { promoCodeManager } from 'services/PromoCodeManager'
import type {
  DiscountCoupon,
  FreeItemCreditCoupon,
} from '../promoEntries.types'

type PromoInputsSnapshot = {
  promocode: string | null
  giftCodes: string[]
  tileCredits: FreeItemCreditCoupon[]
  discountCoupon: DiscountCoupon | null
}

const EMPTY_PROMO_INPUTS_SNAPSHOT: PromoInputsSnapshot = {
  promocode: null,
  giftCodes: [],
  tileCredits: [],
  discountCoupon: null,
}

let lastPromoInputsSnapshot = EMPTY_PROMO_INPUTS_SNAPSHOT
let lastPromoInputsKey = JSON.stringify(EMPTY_PROMO_INPUTS_SNAPSHOT)

function getPromoInputsSnapshot(): PromoInputsSnapshot {
  const promocode = promoCodeManager.getDiscountCouponCode() ?? null
  const giftCodes = [...promoCodeManager.getGiftCardCreditsCodes()].sort()
  const tileCredits =
    promoCodeManager.getAllTileCredits() as FreeItemCreditCoupon[]
  const discountCoupon =
    promoCodeManager.getDiscountCoupon() as DiscountCoupon | null

  const nextSnapshot = { promocode, giftCodes, tileCredits, discountCoupon }
  const nextKey = JSON.stringify(nextSnapshot)

  if (lastPromoInputsKey !== nextKey) {
    lastPromoInputsKey = nextKey
    lastPromoInputsSnapshot = nextSnapshot
  }

  return lastPromoInputsSnapshot
}

function subscribeToPromoInputs(onStoreChange: () => void): () => void {
  const subscription = promoCodeManager.promoCodeSubject.subscribe(() =>
    onStoreChange()
  )

  return () => subscription.unsubscribe()
}

export function useCheckoutPromoInputs(): PromoInputsSnapshot {
  return useSyncExternalStore(
    subscribeToPromoInputs,
    getPromoInputsSnapshot,
    () => EMPTY_PROMO_INPUTS_SNAPSHOT
  )
}
